import React, {memo} from 'react';
import './index.scss';

import {FooterComponent} from './component';

import {toggleScenarioFooterPopupScreenAction} from "../../store/ui/actions"
import {ScenarioModel} from '../../store/control/state';
import {useDispatch, useSelector} from 'react-redux';

type Props = {
    locked: boolean;
};

export const Footer = memo(function Footer(props: Props) {
    const dispatch = useDispatch();
    const scenarioList = useSelector(state => state.control.scenarioList);
    const scenarioListFiltered = scenarioList
        .filter(scenario => scenario.show_on_footer)
        .slice(0, 6);

    return (
        <FooterComponent
            locked={props.locked}
            scenarioModelList={scenarioListFiltered}
            onScenarioClick={(scenario: ScenarioModel) => dispatch(toggleScenarioFooterPopupScreenAction(scenario))}/>
    );
});
